import {Component, OnInit} from '@angular/core';
import {AdService} from '@services/ad.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-redirect',
    template: '',
})
export class RedirectComponent implements OnInit {

    constructor(
        private adService: AdService,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.adService.getFavoritesLists().subscribe(result => {
            this.router.navigate(['/app/favorites', result[0].id]);
        });
    }
}
